import React, { useState, useEffect } from "react";
import { teksAPI } from "../services/api";
import "./TEKSModal.css";

const TEKSModal = ({ teksCode, courseId, onClose }) => {
  const [teksData, setTeksData] = useState(null);
  const [alignment, setAlignment] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!teksCode) return;

    const loadTeks = async () => {
      setLoading(true);
      try {
        const alignmentResponse = await teksAPI.getAlignment(teksCode, courseId);
        const rows = alignmentResponse.data || [];
        const filteredRows = courseId
          ? rows.filter((item) => item.course_id === courseId)
          : rows;

        setAlignment(filteredRows);
        if (filteredRows.length > 0) {
          setTeksData(filteredRows[0]);
        } else {
          setTeksData(null);
        }
      } catch (error) {
        console.error("Error loading TEKS:", error);
        setAlignment([]);
        setTeksData(null);
      } finally {
        setLoading(false);
      }
    };

    loadTeks();
  }, [courseId, teksCode]);

  if (loading) {
    return (
      <div className="teks-modal">
        <div className="modal-content">
          <div className="loading">Loading standard details...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="teks-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        {teksData && (
          <>
            <div className="teks-header">
              <h2>TEKS Standard: {teksData.teks_code}</h2>
              <div className="teks-meta">
                <span
                  className={`category-badge ${teksData.category.toLowerCase()}`}
                >
                  {teksData.category}
                </span>
                <span className="cba-weight">
                  CBA Items: {teksData.cba_item_weight}
                </span>
              </div>
            </div>

            <div className="teks-description">
              <h3>Standard Description</h3>
              <p>{teksData.description}</p>
            </div>

            {alignment.length > 1 && (
              <div className="vertical-alignment">
                <h3>Vertical Alignment (Across Grade Levels)</h3>
                <div className="alignment-list">
                  {alignment.map((item) => (
                    <div key={item.id} className="alignment-item">
                      <div className="grade-level">
                        Grade {item.grade_level}
                      </div>
                      <div className="alignment-detail">
                        <strong>{item.course_name}</strong>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="teks-info">
              <h3>Assessment Information</h3>
              <p>
                <strong>CBA Weight:</strong> {teksData.cba_item_weight} items on
                district assessment
              </p>
              <p>
                <strong>Category:</strong> {teksData.category}
                {teksData.category === "Readiness" && (
                  <span className="note">
                    {" "}
                    - Heavily tested on state assessments
                  </span>
                )}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TEKSModal;
